import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Table } from '@imcva/reactstrap-table'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import Card from 'src/components/Card'
import { useReportBuilderReports } from 'src/queries/cat/reporting/reportbuilder/useReportBuilderReports'
import { columns } from './columns'

const List: React.FC = () => {
  const reports = useReportBuilderReports()
  const navigate = useNavigate()

  return (
    <Card
      title='Saved Reports'
      primaryAction={{
        key: 'new-report',
        icon: faPlus,
        text: 'New Report',
        onClick: () => navigate('/cat/views/reportbuilder/new')
      }}
    >
      <Table storageKey='report-builder-reports' options={{ data: reports, columns }} />
    </Card>
  )
}

export default List
